import api from './api';
import * as mock from './mocks/mentorBooking.mock';

// The one place the mentor-booking pages get their data from.
//
// The real endpoints (GET /mentors/bookable, GET /mentors/:id/slots, POST /sessions) are the
// default. Set REACT_APP_MENTOR_BOOKING_MOCK=true to develop against the in-memory mock
// (services/mocks/mentorBooking.mock.js) with no backend.
const USE_MOCK = process.env.REACT_APP_MENTOR_BOOKING_MOCK === 'true';

// Mentors the student can book. CONTRACT: the server returns only the mentor(s) linked to
// the logged-in student (through their projects), never every bookable mentor. The UI does
// no filtering of its own, so scoping must happen in GET /mentors/bookable. The slots and
// booking endpoints must likewise refuse (404/403) any mentor the student is not linked to.
export const getBookableMentors = async () => {
  if (USE_MOCK) return mock.getBookableMentors();
  const response = await api.get('/mentors/bookable');
  return response.data;
};

// Open slots for one mentor, grouped by day, times rendered server-side in `timezone`.
export const getMentorSlots = async (mentorId, { timezone, dateFrom, dateTo } = {}) => {
  if (USE_MOCK) return mock.getMentorSlots(mentorId, { timezone, dateFrom, dateTo });
  const response = await api.get(`/mentors/${mentorId}/slots`, {
    params: { timezone, date_from: dateFrom, date_to: dateTo }
  });
  return response.data;
};

// project_id is required when the student has several projects with this mentor (each mentor in the
// responses above carries `projects: [{ id, project_name }]`); with one project it may be omitted.
export const bookSession = async ({ mentor_id, project_id, start_time_utc, timezone, notes }) => {
  if (USE_MOCK) return mock.bookSession({ mentor_id, project_id, start_time_utc, timezone, notes });
  const response = await api.post('/sessions', { mentor_id, project_id, start_time_utc, timezone, notes });
  return response.data;
};
